// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPage_container__10fxD","visible":"LoadingPage_visible__Jc2g7","label":"LoadingPage_label__1RuTr"};